import * as React from "react";
import {Button, Icon, Label} from "semantic-ui-react";
import {ScriptDropdown} from "../ScriptConverterPlayground/ScriptDropdown";
import {ScriptSelectorModal} from "./AiAgentTaskScriptsTableModal";

export interface ScriptSelectorProps {
    scriptPath: string | undefined;
    setScriptPath: (scriptPath: string | undefined) => void;
    setScript: (script: string) => void;
    readOnly?: boolean;
}
export function ScriptSelector(props: React.PropsWithChildren<ScriptSelectorProps>) {

    const [dropdownRefreshKey, setDropdownRefreshKey] = React.useState(0);
    const [scriptSelectorModalOpen, setScriptSelectorModalOpen] = React.useState(false);

    function getLabelColor(missing: boolean) {
        return missing ? "red" : "green";
    }
    return <>
        <Label
            color={getLabelColor(!props.scriptPath || props.scriptPath.length === 0)}
            style={{textAlign: "center"}}
        >
            Script Path
        </Label>
        <div style={{display: "flex", alignItems: "center", width: "100%", marginTop: "3px"}}>
            <div style={{flex: 1}}>
                <ScriptDropdown
                    key={`script-dropdown-${dropdownRefreshKey}`}
                    scriptPath={props.scriptPath}
                    setScriptPath={props.setScriptPath}
                    setScript={props.setScript}
                    readOnly={props.readOnly}
                />
            </div>
            <Button
                icon
                style={{marginLeft: "10px"}}
                onClick={() => setScriptSelectorModalOpen(true)}
                title="Browse scripts in table view"
            >
                <Icon name="table"/>
            </Button>
        </div>
        <ScriptSelectorModal
            isOpen={scriptSelectorModalOpen}
            onClose={() => setScriptSelectorModalOpen(false)}
            scriptPath={props.scriptPath}
            setScriptPath={props.setScriptPath}
            setScript={props.setScript}
        />
        </>
}